import './App.css';
import Navbar from './components/navbar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Homepage from './pages/homepage';
import Footer from './components/footer';
import EnterpriseAndCorporate from './pages/solutions/enterprise-and-corporate';
import UmkmAndRetail from './pages/solutions/umkm-and-retail';
import EducationAndTraining from './pages/solutions/education-and-training';
import Careers from './pages/resources/careers';
import HalauMereka from './pages/halaumereka';
import ContactUs from './pages/contact-us';
import NotFound from './pages/not-found';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

function App() {
  return (
    <div className="App">
        <BrowserRouter>
          <Navbar/>
          <Routes>
            <Route path="/" element={<Homepage/>}></Route>
            <Route path="/solutions/enterprise-and-corporate" element={<EnterpriseAndCorporate/>}></Route>
            <Route path="/solutions/umkm-and-retail" element={<UmkmAndRetail/>}></Route>
            <Route path="/solutions/education-and-training" element={<EducationAndTraining/>}></Route>
            <Route path="/resources/careers" element={<Careers/>}></Route>
            <Route path='/halaumereka' element={<HalauMereka/>}></Route>
            <Route path='/contact-us' element={<ContactUs/>}></Route>
            <Route path='*' element={<NotFound/>}></Route>
          </Routes>
          <Footer/>
        </BrowserRouter>
        <Analytics/>
        <SpeedInsights/>
    </div>
  );
}

export default App;
